import BeatportLogo from '@components/icons/BeatportLogo';
import React from 'react';

import './Error.scss';

type ErrorProps = {
  title: string;
  error?: Error;
}

const ErrorComponent: React.FC<ErrorProps> = (props) => {
  return (
    <div className="Error">
      <BeatportLogo className="Error__logo" />
      {props.title && <h2>{props.title}</h2>}
      {props.children}
      {WEBPACK_ENV === 'development' && props.error &&  (
        <div className="Error__stack">
          <pre>
            {props.error.stack}
          </pre>
        </div>
      )}
    </div>
  )
}

export default ErrorComponent;